import SmartTipDetails from './SmartTipsDetails';

export default SmartTipDetails;
